<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 17h-6.5v-1H19a1 1 0 001-1 8 8 0 00-7.5-8V6H15a1 1 0 000-2H9a1 1 0 000 2h2.5v1A8 8 0 004 15a1 1 0 001 1h6.5v1H5a1 1 0 000 2h14a1 1 0 000-2zm-7-8a6 6 0 015.92 5H6.08A6 6 0 0112 9z"/></svg>